import * as React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Stack,
  Grid,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { convertNumberToGrade, getMaxScore } from "./action";
import { schoolMarkingAccess } from "../schoolMarkingAccess";

// result: resultText, vocab: updateResultRecord.vocab, variants: updateResultRecord.variants, wordCount: updateResultRecord.wordCount
export default function DisplayMarkingComment(props) {
  const { gradeResult, mode, schoolAccess } = props;
  const schoolCode = schoolAccess ? schoolAccess.code : "";
  const hasSchoolMarkingAccess = schoolMarkingAccess.includes(schoolCode);

  console.log("DisplayMarkingComment", gradeResult, mode);
  const useSimpifiedChinese = mode === "IGCSE" || mode === "IB" ? true : false;

  // const isNewDSEVersion =
  //   mode === "DSE" &&
  //   gradeResult?.grade?.some((section) => section.item === "表達")
  //     ? true
  //     : false;
  // console.log("isNewDSEVersion", isNewDSEVersion);
  // console.log("gradeResult", gradeResult);
  return (
    <div>
      {gradeResult.grade ? (
        <>
          {gradeResult.grade?.map((item, index) => {
            return (
              <Accordion
                key={`grade-${index}`}
                //onChange={handleChange(`panel${index}`)}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography>
                    【{item.id}】 {item.item}{" "}
                    {mode !== "Pre-S1" &&
                    mode !== "中國語文第二語言學習架構" &&
                    mode !== "校本評核"
                      ? item.score
                        ? `（${convertNumberToGrade(
                            item.score
                          )}等）（最高${convertNumberToGrade(
                            getMaxScore(item.id, mode)
                          )}等）`
                        : item.grade
                        ? `（${item.grade}等）（最高${convertNumberToGrade(
                            getMaxScore(item.id, mode)
                          )}等）`
                        : ""
                      : ""}
                    {/* {mode === "Pre-S1" && item.grade
                      ? `（${item.grade}等）`
                      : ""} */}
                    {mode === "Pre-S1"
                      ? item.id === 5 && item.score != 0
                        ? `（扣 ${item.score} 分）/（扣 3 分）`
                        : item.id === 5 && item.score == 0
                        ? `（不扣分）`
                        : `（${item.score} 分）/ ${getMaxScore(
                            item.id,
                            "Pre-S1"
                          )} 分`
                      : ""}
                    {mode === "中國語文第二語言學習架構"
                      ? `（層階代號：${item.grade}）`
                      : ""}
                    {mode === "校本評核" && hasSchoolMarkingAccess
                      ? `（${item.score} 分）/ ${getMaxScore(
                          item.id,
                          "校本評核",
                          schoolCode
                        )} 分`
                      : ""}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Stack direction="column">
                    <Grid container direction={"column"}>
                      {item?.comment && typeof item.comment === "string" && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            評語
                          </Typography>
                          <Typography>{item.comment}</Typography>
                        </>
                      )}
                      {item?.comment?.chinese && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            評語
                          </Typography>
                          <Typography>{item.comment.chinese}</Typography>
                        </>
                      )}
                      {item?.comment?.english && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            Comment
                          </Typography>
                          <Typography>{item.comment.english}</Typography>
                        </>
                      )}
                      {item?.pros && typeof item.pros === "string" && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            {useSimpifiedChinese
                              ? "应继续保持的地方"
                              : "應繼續保持的地方"}
                          </Typography>
                          <Typography>{item.pros}</Typography>
                        </>
                      )}
                      {item?.cons && typeof item.cons === "string" && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            {useSimpifiedChinese
                              ? "应改进的地方"
                              : "應改進的地方"}
                          </Typography>
                          <Typography>{item.cons}</Typography>
                        </>
                      )}
                      {item?.pros?.chinese && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            {useSimpifiedChinese
                              ? "应继续保持的地方"
                              : "應繼續保持的地方"}
                          </Typography>
                          <Typography>{item.pros.chinese}</Typography>
                        </>
                      )}
                      {item?.cons?.chinese && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            {useSimpifiedChinese
                              ? "应改进的地方"
                              : "應改進的地方"}
                          </Typography>
                          <Typography>{item.cons.chinese}</Typography>
                        </>
                      )}
                      {item?.pros?.english && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            Areas to Maintain
                          </Typography>
                          <Typography>{item.pros.english}</Typography>
                        </>
                      )}
                      {item?.cons?.english && (
                        <>
                          <Typography variant="h5" sx={{ m: 1 }}>
                            Areas for Improvement
                          </Typography>
                          <Typography>{item.cons.english}</Typography>
                        </>
                      )}
                      {item?.情節數目
                        ? item?.情節數目 > 0 && (
                            <Typography variant="h5" sx={{ m: 1 }}>
                              情節數目：{item?.情節數目}
                            </Typography>
                          )
                        : ""}
                      {item?.列出情節
                        ? typeof item?.列出情節 === "string" && (
                            <Typography>{item?.列出情節}</Typography>
                          )
                        : ""}
                    </Grid>
                  </Stack>
                  {item?.contents &&
                    item.contents?.map((content, index) => {
                      return (
                        <Accordion key={`grade-${index}`}>
                          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography>
                              【{item.id}.{index + 1}】 {content.item}
                              {mode === "IGCSE" &&
                              (content.score || content.score === 0)
                                ? `（${content.score}分）/ ${getMaxScore(
                                    content.id,
                                    "IGCSE"
                                  )}分`
                                : ""}
                              {mode !== "IGCSE"
                                ? content.score
                                  ? `（${convertNumberToGrade(
                                      content.score
                                    )}等）（最高${convertNumberToGrade(
                                      getMaxScore(content.id, mode)
                                    )}等）`
                                  : `（${
                                      content.grade
                                    }等）（最高${convertNumberToGrade(
                                      getMaxScore(content.id, mode)
                                    )}等）`
                                : ""}
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            <Stack direction="column">
                              {content?.comment &&
                                typeof content.comment === "string" && (
                                  <>
                                    <Typography variant="h5" sx={{ m: 1 }}>
                                      評語
                                    </Typography>
                                    {content.comment}
                                  </>
                                )}
                              {content?.comment?.chinese && (
                                <>
                                  <Typography variant="h5" sx={{ m: 1 }}>
                                    評語
                                  </Typography>
                                  {content.comment.chinese}
                                </>
                              )}
                              {content?.comment?.english && (
                                <>
                                  <Typography variant="h5" sx={{ m: 1 }}>
                                    Comment
                                  </Typography>
                                  {content.comment.english}
                                </>
                              )}
                              {content?.pros &&
                                typeof content.pros === "string" && (
                                  <>
                                    <Typography variant="h5" sx={{ m: 1 }}>
                                      {useSimpifiedChinese
                                        ? "应继续保持的地方"
                                        : "應繼續保持的地方"}
                                    </Typography>
                                    {content.pros}
                                  </>
                                )}
                              {content?.cons &&
                                typeof content.cons === "string" && (
                                  <>
                                    <Typography variant="h5" sx={{ m: 1 }}>
                                      {useSimpifiedChinese
                                        ? "应改进的地方"
                                        : "應改進的地方"}
                                    </Typography>
                                    {content.cons}
                                  </>
                                )}
                              {content?.pros?.chinese && (
                                <>
                                  <Typography variant="h5" sx={{ m: 1 }}>
                                    {useSimpifiedChinese
                                      ? "应继续保持的地方"
                                      : "應繼續保持的地方"}
                                  </Typography>
                                  {content.pros.chinese}
                                </>
                              )}
                              {content?.cons?.chinese && (
                                <>
                                  <Typography variant="h5" sx={{ m: 1 }}>
                                    {useSimpifiedChinese
                                      ? "应改进的地方"
                                      : "應改進的地方"}
                                  </Typography>
                                  {content.cons.chinese}
                                </>
                              )}
                              {content?.pros?.english && (
                                <>
                                  <Typography variant="h5" sx={{ m: 1 }}>
                                    Areas to Maintain
                                  </Typography>
                                  {content.pros.english}
                                </>
                              )}
                              {content?.cons?.english && (
                                <>
                                  <Typography variant="h5" sx={{ m: 1 }}>
                                    Areas for Improvement
                                  </Typography>
                                  {content.cons.english}
                                </>
                              )}
                            </Stack>
                          </AccordionDetails>
                        </Accordion>
                      );
                    })}
                </AccordionDetails>
              </Accordion>
            );
          })}
        </>
      ) : null}
      {gradeResult?.totalScore ? (
        <Box
          sx={{
            mt: 1,
            p: 2,
            width: "100%",
            backgroundColor: "#FEFEFE",
          }}
        >
          <Typography>
            {`【總分: (${gradeResult.totalScore}) / 28分 】`}
          </Typography>
        </Box>
      ) : (
        ""
      )}
      {gradeResult?.suggestion ? (
        <Stack sx={{ mt: 1 }}>
          <Accordion sx={{ mb: 1, width: "100%", position: "relative" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                【
                {gradeResult?.suggestion?.item
                  ? gradeResult.suggestion.item
                  : "改進建議"}
                】
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction={"column"}>
                {gradeResult?.suggestion?.comment &&
                  typeof gradeResult?.suggestion?.comment === "string" && (
                    <>
                      <Typography variant="h5" sx={{ m: 1 }}>
                        建議
                      </Typography>
                      {gradeResult.suggestion.comment}
                    </>
                  )}
                {gradeResult?.suggestion?.comment?.chinese && (
                  <>
                    <Typography variant="h5" sx={{ m: 1 }}>
                      {!useSimpifiedChinese ? "建議" : "建议"}
                    </Typography>
                    {gradeResult.suggestion.comment.chinese}
                  </>
                )}
                {gradeResult?.suggestion?.comment?.english && (
                  <>
                    <Typography variant="h5" sx={{ m: 1 }}>
                      Suggestions
                    </Typography>
                    {gradeResult.suggestion.comment.english}
                  </>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
      ) : null}
      {gradeResult?.overall && (
        <Stack sx={{ mt: 1 }}>
          <Accordion sx={{ mb: 1, width: "100%", position: "relative" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>
                【
                {gradeResult?.overall?.item
                  ? gradeResult.overall.item
                  : "整體評核"}{" "}
                {mode === "校本評核" && hasSchoolMarkingAccess
                  ? `(總分: ${gradeResult.overall?.score}) / 100分`
                  : ""}
                {mode !== "Pre-S1" && mode !== "校本評核"
                  ? gradeResult.overall?.score
                    ? `（${convertNumberToGrade(
                        gradeResult.overall?.score
                      )}等）`
                    : `（${gradeResult.overall?.grade}等）`
                  : ""}{" "}
                {mode === "Pre-S1"
                  ? `(總分: ${gradeResult.overall?.score})`
                  : ""}
                】
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction={"column"}>
                {gradeResult?.overall?.comment &&
                  typeof gradeResult?.overall?.comment === "string" && (
                    <>
                      <Typography variant="h5" sx={{ m: 1 }}>
                        評語
                      </Typography>{" "}
                      {gradeResult.overall.comment}
                    </>
                  )}
                {gradeResult?.overall?.comment?.chinese && (
                  <>
                    <Typography variant="h5" sx={{ m: 1 }}>
                      {!useSimpifiedChinese ? "評語" : "评语"}
                    </Typography>
                    {gradeResult.overall.comment.chinese}
                  </>
                )}
                {gradeResult?.overall?.comment?.english && (
                  <>
                    <Typography variant="h5" sx={{ m: 1 }}>
                      Comment
                    </Typography>{" "}
                    {gradeResult.overall.comment.english}
                  </>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Stack>
      )}
    </div>
  );
}
